import Gap from "Components/Gap";
import {StyledText} from "Components/Text";
import styles from "./VerifyEmailPage.module.scss";
import DefaultPageLayout from "../../Layouts/DefaultPageLayout";
import {useTranslation} from "react-i18next";
import Box from "Components/Box";
import EmailIcon from "Assets/Icons/V2/EmailIcon";
import {useNavigate} from "react-router-dom";
import React, {useEffect} from "react";
import {useAuthProvider} from "Providers/AuthProvider";
import OnboardingBoxContent from "Features/Onboarding/Components/OnboardingBoxContent";
import CalendlyBooker from "Features/Onboarding/Components/CalendlyBooker";

const VerifyEmailPage = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();

    const user = useAuthProvider();

    useEffect(() => {
        if (user.firebaseUser?.emailVerified) {
            navigate('dashboard');
        }
    }, [user, navigate])

    return (
        <DefaultPageLayout contentMaxWidth={1440}>
            <div className={styles.content}>

                <div className={styles.headline}>
                    <StyledText type={"Headline"} weight={"Bold"} color={"secondary"}>
                        {t('onboarding.verifyEmail.headline')}
                    </StyledText>
                </div>

                <Box style={{width: 840}}>
                    <OnboardingBoxContent content={(
                        <Gap size={"medium"} direction={"vertical"}>
                            <EmailIcon />

                            <StyledText type={"Caption"}>
                                {t('onboarding.verifyEmail.text1')}
                            </StyledText>

                            <StyledText type={"Caption"}>
                                {t('onboarding.verifyEmail.text2')}
                            </StyledText>
                        </Gap>
                    )} />
                </Box>

                <CalendlyBooker />
            </div>

        </DefaultPageLayout>
    )

}

export default VerifyEmailPage
